import Table from '@components/common/Table';
import React, { useState, useEffect } from 'react';
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from 'react-sortable-hoc/dist/react-sortable-hoc';
import { HoverDiv } from '../styled';

const DraggableContainer = sortableContainer(({ children }) => children);
const DraggableElement = sortableElement(({ children }) => children);
const DraggableHandle = sortableHandle(({ children }) => children);

export const Col = ({ index, children, ...rest }) => {
  if (index === 0) {
    return <div {...rest}>{children}</div>;
  }
  return (
    <DraggableElement index={index}>
      <div {...rest}>
        <HoverDiv>
          <div style={{ display: 'block', width: '100%', textAlign: 'center' }}>
            <DraggableHandle>
              <div
                className="handle"
                style={{ fontSize: '20px', height: '30px', lineHeight: '20px' }}
              >
                ...
              </div>
            </DraggableHandle>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '140px',
              height: '32px',
            }}
          >
            {children}
          </div>
        </HoverDiv>
      </div>
    </DraggableElement>
  );
};

function DragableColumnTable({
  columns,
  onColumnOrderChange,
  data,
  sortBy,
  onColumnSort,
  components,
  total,
}) {
  const [cols, setCols] = useState(columns);
  useEffect(() => {
    setCols(columns);
  }, [columns]);

  const headerCellProps = (args) => ({
    tagName: Col,
    index: args.columnIndex,
  });

  const handleSortEnd = ({ oldIndex, newIndex }) => {
    const newData = [...cols];
    [newData[newIndex], newData[oldIndex]] = [newData[oldIndex], newData[newIndex]];
    setCols(newData);
    onColumnOrderChange(oldIndex, newIndex);
  };
  return (
    <DraggableContainer useDragHandle onSortEnd={handleSortEnd} axis="x">
      <Table
        fixed
        data={data}
        frozenData={total ? [total] : undefined}
        columns={cols}
        rowHeight={86}
        headerHeight={55}
        sortBy={sortBy}
        headerCellProps={headerCellProps}
        onColumnSort={onColumnSort}
        components={components}
      />
    </DraggableContainer>
  );
}
export default React.memo(DragableColumnTable);
